import React from 'react'

import { GREEN_TEXT_KEY } from '@mc/feature-variables'

import { UrgencyCopy, UrgencyCopyProps } from './UrgencyCopy'

export const UrgencyTextGreen = (props: Omit<UrgencyCopyProps, 'textKey'>) => (
  <UrgencyCopy {...props} textKey={GREEN_TEXT_KEY} />
)
